import { BlogList } from '@/components/blog/BlogList'
import { BlogSearch } from '@/components/blog/BlogSearch'
import { SEO } from '@/components/SEO'

export default function Blog() {
  return (
    <>
      <SEO
        title="Blog - WithWords"
        description="Insights, tips, and strategies for AI writing, content marketing, and SEO from WithWords."
      />
      <div className="min-h-screen bg-background">
        <div className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-background/95 -z-10"></div>

          <div className="absolute inset-0 -z-5 opacity-20">
            <div className="absolute top-10 left-1/4 w-64 h-64 bg-primary/20 rounded-full blur-3xl animate-pulse-slow"></div>
            <div className="absolute bottom-10 right-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl animate-pulse-slow animation-delay-2000"></div>
          </div>

          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMwLTkuOTQtOC4wNi0xOC0xOC0xOFYwaDQydjQySDM2VjE4eiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuMDIiLz48cGF0aCBkPSJNMzAgMzBjMC05Ljk0LTguMDYtMTgtMTgtMThIMHY0MmgyNHYtNmMwLTkuOTQtOC4wNi0xOC0xOC0xOHoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjAyIi8+PHBhdGggZD0iTTYgNmMwLTMuMzEtMi42OS02LTYtNnY0OGg0OFY0MmMtOS45NCAwLTE4LTguMDYtMTgtMTggMC05Ljk0LTguMDYtMTgtMTgtMTgtMy4zMSAwLTYtMi42OS02LTZ6IiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC4wMiIvPjwvZz48L3N2Zz4=')]  bg-repeat opacity-5 -z-10"></div>

          <div className="container px-4 py-24 md:py-32 max-w-7xl mx-auto relative">
            <div className="max-w-3xl mx-auto text-center">
              <div className="inline-flex items-center justify-center mb-6 relative">
                <div className="h-px w-8 bg-primary/60 absolute left-0 top-1/2 transform -translate-x-full"></div>
                <span className="text-primary font-semibold text-sm mx-3 tracking-wider uppercase">Insights & Strategies</span>
                <div className="h-px w-8 bg-primary/60 absolute right-0 top-1/2 transform translate-x-full"></div>
              </div>

              <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-foreground to-foreground/80">
                WithWords Blog
              </h1>

              <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
                Insights, tips, and strategies for AI writing, content marketing, and SEO
              </p>

              <div className="mt-10 max-w-xl mx-auto relative z-10">
                <div className="absolute -inset-3 bg-gradient-to-r from-primary/20 via-primary/10 to-primary/20 rounded-lg blur-lg opacity-70 -z-10 animate-pulse-slow"></div>
                <BlogSearch />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-0">
          <BlogList />
        </div>
      </div>
    </>
  )
}